import * as React from 'react';
import { useState } from 'react';
import { Stack, Tabs } from '@mantine/core';
import { Show } from '../../../../../react-commons/components/control-flow/Show';
import {
    VCycleRepresentationViewerComponent,
} from '../../page-components/workflow-representation/VCycleRepresentationViewerComponent';
import {
    VCycleRepresentationEditorComponent,
} from '../../page-components/workflow-representation/VCycleRepresentationEditorComponent';
import { useParams, useSearchParams } from 'react-router-dom';
import { ConditionalComponent } from '../../reusable-components/ConditionalComponent';
import {
    WorkflowRepresentationResource,
} from '../../../resource/resources/artifacts/use_case/representation/workflowRepresentationResource';
import { useUserId } from '../../authentication/useUserId';
import { useUserActions } from '../../../resource/resources/persistables/user/userResource';
import { WorkflowRepresentationType } from '../../../resource/enumerations/WorkflowRepresentationType';
import {
    GridRepresentationViewerComponent
} from '../../page-components/workflow-representation/GridRepresentationViewerComponent';
import { ControlledInputs } from '../../../../../react-commons/utils/read-only-inputs/controlledInputs';

export const WorkFlowRepresentationComponent= ({ workflowResource, inTabs, useCaseObjectId }: {
    workflowResource: WorkflowRepresentationResource
    inTabs?: boolean
    useCaseObjectId: string
}) => {
    const userId = useUserId('');
    const isAuthenticated = Boolean(userId);
    const { id: projectId } = useParams<{ id: string }>();
    const [activeTab, setActiveTab] = useState<string | null>('viewer');
    const [gridEditMode, setGridEditMode] = useState<boolean>(false);

    const [search] = useSearchParams();

    const userActions = useUserActions();
    const userSystemRights = userActions.useGetUserEffectiveRightsOfUser(userId, projectId);

    const isProcessAdmin =
        userSystemRights.data && (userSystemRights.data.isProcessAdmin) && !search.get('publishment');

    return (
        <div className={'main-window-content'}>
            <ConditionalComponent label={'Please login to see Workflow Representation'} condition={isAuthenticated}>
                <Show when={!isProcessAdmin}>
                    { workflowResource.type === WorkflowRepresentationType.GRID ?
                        <GridRepresentationViewerComponent inTabs={inTabs ? 80 : inTabs === undefined ? undefined : 45}
                                                           workflowId={workflowResource.id}
                                                           useCaseObjectId={useCaseObjectId} editMode={false} />
                        :
                        <VCycleRepresentationViewerComponent inTabs={inTabs ? 90 : inTabs === undefined ? undefined : 60}
                                                             workflowId={workflowResource.id}
                                                             useCaseObjectId={useCaseObjectId} />
                    }
                </Show>
                <Show when={isProcessAdmin}>
                    { workflowResource.type === WorkflowRepresentationType.GRID ?
                        <Stack pt={10}>
                            <div style={{paddingLeft: 15, paddingTop: 5}}>
                                <ControlledInputs.BooleanSwitch label={"Edit Mode"} value={gridEditMode} onChange={setGridEditMode} readOnly={false} />
                            </div>
                            <GridRepresentationViewerComponent
                                inTabs={activeTab === 'viewer' ? (inTabs ? 120 : inTabs === undefined ? undefined : 90) : undefined}
                                workflowId={workflowResource.id} useCaseObjectId={useCaseObjectId} editMode={gridEditMode} />
                        </Stack>
                        : (
                            <Tabs value={activeTab} onChange={setActiveTab} style={{ flexGrow: 1 }}>
                                <Tabs.List>
                                    <Tabs.Tab value={'viewer'}>Representation Viewer</Tabs.Tab>
                                    <Tabs.Tab value={'editor'}>Representation Editor</Tabs.Tab>
                                </Tabs.List>
                                <Tabs.Panel value={'viewer'}>
                                    <VCycleRepresentationViewerComponent
                                        inTabs={activeTab === 'viewer' ? (inTabs ? 120 : inTabs === undefined ? undefined : 90) : undefined}
                                        workflowId={workflowResource.id} useCaseObjectId={useCaseObjectId} />
                                </Tabs.Panel>
                                <Tabs.Panel value={'editor'}>
                                    <VCycleRepresentationEditorComponent workflowId={workflowResource.id} />
                                </Tabs.Panel>
                            </Tabs>
                        )
                    }
                </Show>
            </ConditionalComponent>
        </div>
    );
};